export const E2E_AUTH_REFUSAL_MESSAGE =
  "E2E upload tests are allowed only for DEV and DEV_CONSIGNMENT. Refusing to run against this URL.";

const PRODUCTION_HOSTS = new Set([
  "bloomberg-dashboard.clippn.com",
  "consignment-dashboard.clippn.com",
]);

export const isLocalhost = (hostname = "") => {
  const normalized = hostname.toLowerCase();
  return normalized === "localhost" || normalized === "127.0.0.1" || normalized === "::1";
};

export const isAllowedE2EHost = (hostname = "") => {
  const normalized = hostname.toLowerCase();

  if (isLocalhost(normalized)) {
    return true;
  }

  if (PRODUCTION_HOSTS.has(normalized)) {
    return false;
  }

  if (normalized === "forge-dashboard-dev.clippn.com") {
    return true;
  }

  if (!normalized.endsWith(".clippn.com")) {
    return false;
  }

  return /(^|[-.])dev([-.]|$)/.test(normalized) || /(^|[-.])dev[-_]consignment([-.]|$)/.test(normalized);
};
